<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
            <el-breadcrumb-item>轮播图列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                    <el-select v-model="queryInfo.query"  placeholder="请选择门店" @change="getInfoList"  style="width: 220px;" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                  <el-select v-model="queryInfo.type"  placeholder="请选择类型" @change="getInfoList"  style="width: 180px;margin-left:8px;" clearable  filterable>
                    <el-option label="到店指引" value="0"></el-option>
                    <el-option label="首页Banner" value="1"></el-option>
                  </el-select>
                    <!-- <el-input placeholder="请输入关键字" clearable v-model="queryInfo.query" @clear="getInfoList()">
                        <el-button slot="append" icon="el-icon-search" @click="getInfoList()"></el-button>
                    </el-input> -->
                </el-col>
                <el-col :span="12" style="text-align:right;">
                    <el-button icon="el-icon-plus" type="primary" @click="addDialogVisible = true">添加轮播图</el-button>
                    <el-button icon="el-icon-star-on" type="warning" @click="openActivityMgmt" v-permission="'btn:store:banner:festival:setting'">节日活动</el-button>
                    <el-button icon="el-icon-document" type="success" @click="openClaimDialog" v-permission="'btn:store:banner:festival:claim'">节日领取记录</el-button>
                </el-col>
            </el-row>

            <!--搜索与添加区域-->
            <!--列表区域-->
            <el-table :data="infolist" :key="infolist.index" style="width: 100%" stripe size="middle" height="700">

                <el-table-column label="ID" type="index"  width="50"></el-table-column>
                <el-table-column label="标题" prop="title"  width="200"></el-table-column>
                <el-table-column label="图片" prop="title"  :width="queryInfo.query == '' ? '300' :'1100'">
                    <template slot-scope="scope" v-if="scope.row.pic">
                        <el-popover placement="bottom"  width="340" trigger="click">
                            <div style="text-align: center;"><img :src="imgURL+'static/swipers/'+scope.row.pic" style="width:300px"></div>
                            <img :src="imgURL+'static/swipers/'+scope.row.pic" style="width:50px" slot="reference">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="链接类型" prop="urltype"  width="150" v-if="queryInfo.query == ''">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.urltype == '1'">公众号</span>
                        <span  v-if="scope.row.urltype == '2'">视频号</span>
                        <span  v-if="scope.row.urltype == '3'">小红书</span>
                        <span  v-if="scope.row.urltype == '4'">H5</span>
                        <span  v-if="scope.row.urltype == '5'">节日活动</span>
                        <span  v-if="scope.row.urltype == '6'">内部跳转</span>
                    </template>
                </el-table-column>
                <el-table-column label="链接" prop="url"  width="600" v-if="queryInfo.query == ''"></el-table-column>
                <!-- <el-table-column label="发布日期" prop="adddate"  width="200"></el-table-column> -->
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="success" icon="el-icon-edit" size="mini" @click="EditInfo(scope.row.id)"></el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加轮播图" :visible.sync="addDialogVisible" width="60%" top="50px" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px">
                    <el-form-item label="选择门店" prop="storeid">
                        <el-select v-model="addForm.storeid"  placeholder="请选择门店"  style="width: 280px;" clearable filterable>
                            <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="轮播图标题" prop="title">
                        <el-input v-model="addForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="轮播图图片" prop="goods_pic">
                        <!-- {{uploadurl}} -->
                        <el-upload
                            ref="imgBroadcastUpload"
                            :auto-upload="true"
                            multiple
                            :file-list="fileList"
                            :on-change="addPic"
                            :on-remove="addRemove"
                            :on-error="addUploadError"
                            :http-request="photoRequest"
                            list-type="picture-card"
                            accept=".jpg,.png"
                            :before-upload="beforeUpload"
                            :action="uploadurl"
                            :data="{folderType: 'swipers'}">
                                <i class="el-icon-plus"></i>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="链接类型" prop="urltype" v-if="addForm.storeid == ''">
                        <el-select  v-model="addForm.urltype"  placeholder="请选择类型" style="width:300px">
                            <el-option  label="公众号" value="1"></el-option>
                            <el-option  label="视频号" value="2"></el-option>
                            <el-option  label="小红书" value="3"></el-option>
                            <el-option  label="H5" value="4"></el-option>
                            <el-option  label="节日活动" value="5"></el-option>
                            <el-option  label="内部跳转" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="addForm.urltype == 2 ? '视频ID': addForm.urltype == 6 ? '页面路径': '链接'" prop="url" v-if="addForm.storeid == ''">
                        <el-input v-model="addForm.url"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button @click="AddInfo" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!-- 编辑对话框 -->
            <el-dialog title="编辑轮播图" :visible.sync="editDialogVisible" width="60%" top="50px" @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px">
                    <el-form-item label="轮播图标题" prop="title">
                        <el-input v-model="editForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="轮播图图片" prop="goods_pic">

                        <el-upload
                            ref="imgBroadcastUpload"
                            :limit="limitNum"
                            :auto-upload="true"
                            :file-list="fileList"
                            :on-success="editPic"
                            list-type="picture-card"
                            accept=".jpg,.png"
                            :before-upload="beforeUpload"
                            :action="uploadurl"
                            :data="{folderType: 'swipers'}">
                                <i class="el-icon-plus"></i>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500KB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="链接类型" prop="urltype" v-if="editForm.storeid == ''">
                        <el-select  v-model="editForm.urltype"  placeholder="请选择类型" style="width:300px">
                            <el-option  label="公众号" value="1"></el-option>
                            <el-option  label="视频号" value="2"></el-option>
                            <el-option  label="小红书" value="3"></el-option>
                            <el-option  label="H5" value="4"></el-option>
                            <el-option  label="节日活动" value="5"></el-option>
                            <el-option  label="内部跳转" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="editForm.urltype == 2 ? '视频ID': editForm.urltype == 6 ? '页面路径': '链接'" prop="url" v-if="editForm.storeid == ''">
                        <el-input v-model="editForm.url"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button @click="EditInfoSave" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>

        <!-- 节日活动管理弹窗 -->
        <el-dialog title="节日活动管理" :visible.sync="activityMgmtVisible" width="56%" top="30px">
            <div style="margin-bottom:12px;">
                <el-button type="primary" icon="el-icon-plus" @click="openAddActivity">添加活动</el-button>
            </div>
            <el-table :data="activityList" v-loading="activityListLoading" stripe border size="small">
                <el-table-column label="活动ID" prop="activity_id" width="170" show-overflow-tooltip></el-table-column>
                <el-table-column label="活动名称" prop="activity_name" min-width="120"></el-table-column>
                <el-table-column label="礼物名称" prop="gift_name" width="120"></el-table-column>
                <el-table-column label="开始时间" prop="start_time" width="160"></el-table-column>
                <el-table-column label="结束时间" prop="end_time" width="160"></el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.status == 1" @change="toggleActivityStatus(scope.row)"
                            active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        <div style="font-size:11px;color:#999;margin-top:2px;">{{ scope.row.status == 1 ? '开启' : '关闭' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="openEditActivity(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="deleteActivity(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer">
                <el-button @click="activityMgmtVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 添加/编辑活动子弹窗 -->
        <el-dialog :title="activityFormMode === 'add' ? '添加活动' : '编辑活动'" :visible.sync="activityFormVisible" width="480px" append-to-body>
            <el-form :model="activityForm" label-width="90px">
                <el-form-item label="活动名称" required>
                    <el-input v-model="activityForm.activityName" placeholder="如: 2025端午节活动"></el-input>
                </el-form-item>
                <el-form-item label="开始日期" required>
                    <el-date-picker v-model="activityForm.startTime" type="datetime" placeholder="选择开始时间"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" required>
                    <el-date-picker v-model="activityForm.endTime" type="datetime" placeholder="选择结束时间"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="礼物名称">
                    <el-input v-model="activityForm.giftName" placeholder="如: 端午礼盒"></el-input>
                </el-form-item>
                <el-form-item label="活动状态">
                    <el-switch v-model="activityForm.status" :active-value="1" :inactive-value="0"
                        active-text="开启" inactive-text="关闭" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="activityFormVisible = false">取消</el-button>
                <el-button type="primary" @click="saveActivity" :loading="activitySaving">保存</el-button>
            </span>
        </el-dialog>

        <!-- 节日领取记录弹窗 -->
        <el-dialog title="节日活动领取记录" :visible.sync="claimDialogVisible" width="90%" top="30px">
            <div style="display:flex;gap:12px;margin-bottom:16px;flex-wrap:wrap;">
                <el-select v-model="claimQuery.activityId" placeholder="全部活动" clearable style="width:200px;">
                    <el-option v-for="a in activityOptions" :key="a.activity_id" :label="a.activity_name" :value="a.activity_id"></el-option>
                </el-select>
                <el-select v-model="claimQuery.giftStatus" placeholder="礼物状态" clearable style="width:140px;">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="待发放" :value="0"></el-option>
                    <el-option label="已发放" :value="1"></el-option>
                    <el-option label="已签收" :value="2"></el-option>
                </el-select>
                <el-button type="primary" @click="loadClaimList">查询</el-button>
              <el-button
                  type="primary"
                  icon="el-icon-upload"
                  @click="exportInfos"
              >导出Excel</el-button>
            </div>
            <el-table :data="claimList" stripe border size="small" height="500">
                <el-table-column label="ID" prop="id" width="60"></el-table-column>
                <el-table-column label="活动" prop="activity_name" width="130"></el-table-column>
                <el-table-column label="提交人" prop="openid" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="收件人" prop="recipient_name" width="90"></el-table-column>
                <el-table-column label="手机号" prop="recipient_phone" width="120"></el-table-column>
                <el-table-column label="地址" prop="recipient_address" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="抖音核销码" prop="douyin_code" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="提交时间" prop="create_time" width="160"></el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.gift_status===0" type="warning" size="small">待发放</el-tag>
                        <el-tag v-else-if="scope.row.gift_status===1" type="success" size="small">已发放</el-tag>
                        <el-tag v-else-if="scope.row.gift_status===2" type="info" size="small">已签收</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="快递" prop="express_no" width="130" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.gift_status===0" type="primary" size="mini" @click="openSendDialog(scope.row)">标记发货</el-button>
                        <span v-else style="color:#999;font-size:12px;">已处理</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align:center;margin-top:16px;">
                <el-pagination @current-change="onClaimPageChange" :current-page="claimQuery.page"
                    :page-size="claimQuery.size" layout="total, prev, pager, next" :total="claimTotal"></el-pagination>
            </div>
        </el-dialog>

        <!-- 标记发货弹窗 -->
        <el-dialog title="标记发货" :visible.sync="sendDialogVisible" width="420px">
            <el-form :model="sendForm" label-width="90px">
                <el-form-item label="收件人">{{sendForm.recipientName}}</el-form-item>
                <el-form-item label="快递公司">
                    <el-input v-model="sendForm.expressCompany" placeholder="如: 顺丰"></el-input>
                </el-form-item>
                <el-form-item label="快递单号">
                    <el-input v-model="sendForm.expressNo" placeholder="请输入快递单号"></el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-input v-model="sendForm.sendOperator" placeholder="操作人姓名"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="sendDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmSend">确认发货</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {Loading} from "element-ui";
import axios from "axios";

export default {
    data() {
        return{
            imgURL:this.GLOBAL.imgURL,
            uploadurl: this.GLOBAL.imgURL+'upload/',
            limitNum: 1,
            fileList:[],
            uploadQueue: Promise.resolve(),
            infolist: [],
            addDialogVisible:false,
            editDialogVisible:false,
            tag: false,
            //获取列表的参数对象
            queryInfo: {
                query: '',
              type: '',
                pagenum: 1,
                pagesize: 20
            },
            total: 0,
            //添加表单数据
            addForm:{
                storeid:'',
                title:'',
                urltype:'',
                url:'',
                pic:''
            },
            editForm: {},

            //添加表单验证规则
            addFormRules:{
                title:[
                    { required: true, message: '请输入轮播图标题', trigger: 'blur' }
                ]
            },
            editFormRules:{
                title:[
                    { required: true, message: '请输入轮播图标题', trigger: 'blur' }
                ]
            },
            storelist:[],

            // 节日活动管理
            activityMgmtVisible: false,
            activityList: [],
            activityListLoading: false,
            activityFormVisible: false,
            activityFormMode: 'add',
            activityEditId: '',
            activitySaving: false,
            activityForm: { activityName: '', startTime: '', endTime: '', giftName: '', status: 1 },
            activityOptions: [],

            // 领取记录
            claimDialogVisible: false,
            claimList: [],
            claimTotal: 0,
            claimQuery: { activityId: '', giftStatus: null, page: 1, size: 20 },

            // 标记发货
            sendDialogVisible: false,
            sendForm: { id: null, recipientName: '', expressCompany: '', expressNo: '', sendOperator: '' }
        }

    },
    mounted(){
        this.getInfoList()
        this.getStoreList()
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token')
    },
    methods:{
        async getStoreList(){
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data
        },
        async getInfoList() {

            const { data: res} = await this.$http.get('swiperlist/',{ params: this.queryInfo })

            if(res.status == 1){
                 this.total = res.data.totalCount;
                 this.infolist = res.data.list.map(v => {
                 return v.fields
                 })
             }
             for (let index = 0; index < res.data.list.length; index++) {
                     this.infolist[index].id= res.data.list[index].pk;
                 }

         },
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 2;  // 检查文件大小是否小于500K
            if (!isLt1M) {
                this.$message.error('上传文件大小不能超过 2MB!');
            }
            return isLt1M;  // 返回 false 会停止上传
        },
        // 按选择顺序将多张图片文件名拼接为逗号分隔字符串
        buildPicStr(fileList){
            return fileList.map(f => {
                let name = f.name
                if (f.response) name = f.response.picname || f.response.url || f.name
                return name.split('/').pop()
            }).join(',')
        },
        addPic(file, fileList){
            this.addForm.pic = this.buildPicStr(fileList)
        },
        addRemove(file, fileList){
            this.addForm.pic = this.buildPicStr(fileList)
        },
        addUploadError(){
            this.$message.error('图片上传失败，请检查网络后重试')
        },
        // 串行上传：多张图片一次只上传一张，避免并发请求导致服务端只保存第一张
        photoRequest(options){
            const task = this.uploadQueue.then(() => this.doPhotoUpload(options))
            // 队列中单个任务失败不影响后续上传
            this.uploadQueue = task.catch(() => {})
            // 返回带 abort 的 thenable，兼容 el-upload 的取消逻辑
            return {
                then: (resolve, reject) => task.then(resolve, reject),
                catch: fn => task.catch(fn),
                abort: () => {}
            }
        },
        doPhotoUpload(options){
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest()
                xhr.open('POST', options.action, true)
                if (options.withCredentials && 'withCredentials' in xhr) {
                    xhr.withCredentials = true
                }
                const headers = options.headers || {}
                Object.keys(headers).forEach(key => {
                    if (headers[key] !== null && headers[key] !== undefined) {
                        xhr.setRequestHeader(key, headers[key])
                    }
                })
                const formData = new FormData()
                if (options.data) {
                    Object.keys(options.data).forEach(key => formData.append(key, options.data[key]))
                }
                formData.append(options.filename || 'file', options.file)
                if (xhr.upload) {
                    xhr.upload.onprogress = (e) => {
                        if (e.lengthComputable && options.onProgress) {
                            options.onProgress({ percent: Math.round(e.loaded / e.total * 100) })
                        }
                    }
                }
                xhr.onerror = () => reject(new Error('网络错误'))
                xhr.onload = () => {
                    if (xhr.status < 200 || xhr.status >= 300) {
                        reject(new Error('上传失败'))
                        return
                    }
                    let data = xhr.responseText
                    try {
                        data = JSON.parse(data)
                    } catch (e) {}
                    resolve(data)
                }
                xhr.send(formData)
            })
        },
        editPic(file, fileList){
            this.editForm.pic = file.picname
        },
        AddInfo(){
            // 等待所有图片上传完成后再提交
            const uploadRef = this.$refs.imgBroadcastUpload
            const pending = uploadRef && uploadRef.uploadFiles && uploadRef.uploadFiles.some(f => f.status === 'ready' || f.status === 'uploading')
            if (pending) {
                return this.$message.warning('图片正在上传，请稍候再试')
            }
            this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                    const { data:res } = await this.$http.post('swiperadd/',this.addForm)
                    if(res.status===0)
                    {
                        this.$message.success('信息添加成功！')
                        this.addDialogVisible = false
                        // location.reload()
                        this.getInfoList()
                        this.fileList = []
                    }
            })
        },
        async EditInfo(id){
            const { data: res } = await this.$http.get('swiperinfo/' + id)
            this.editForm = res.data
            this.editForm.admin_token =window.sessionStorage.getItem('admin_token')
            // 回显已有图片（多张以逗号分隔）
            const pics = (this.editForm.pic || '').split(',').filter(Boolean)
            this.fileList = pics.map(p => ({ name: p, url: this.imgURL+'static/swipers/'+p, status: 'success' }))
            this.editDialogVisible = true

        },
        EditInfoSave(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const { data: res } = await this.$http.post('swiperedit/' + this.editForm.id,this.editForm)
                if (res.status === 0) {
                    this.$message.success('信息修改成功')
                    this.editDialogVisible = false
                    this.getInfoList()
                }
            })
        },
        async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('swiperdel/'+ id,{ params:{admin_token:this.addForm.admin_token} })

                if (res.status === 0) {
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getInfoList()
        },

        handleSizeChange(newSize){
            this.queryInfo.pagesize = newSize
            this.getInfoList()
        },
        handleCurrentChange(newPage){
            this.queryInfo.pagenum = newPage
            this.getInfoList()
        },
        addDialogClosed(){
                this.$refs.addFormRef.resetFields()
                this.fileList = []
        },
        editDialogClosed(){
                this.$refs.editFormRef.resetFields()
                this.fileList = []
        },

        // 节日活动管理
        openActivityMgmt() {
            this.activityMgmtVisible = true
            this.loadActivityList()
        },
        async loadActivityList() {
            this.activityListLoading = true
            try {
                const { data: res } = await this.$http.get('admin/activityList')
                if (res.status === 0) this.activityList = res.data
            } catch (e) {} finally {
                this.activityListLoading = false
            }
        },
        openAddActivity() {
            this.activityFormMode = 'add'
            this.activityForm = { activityName: '', startTime: '', endTime: '', giftName: '', status: 1 }
            this.activityEditId = ''
            this.activityFormVisible = true
        },
        openEditActivity(row) {
            this.activityFormMode = 'edit'
            const fmtDate = v => {
                if (!v) return ''
                if (typeof v === 'number') {
                    const d = new Date(v)
                    return d.getFullYear() + '-' +
                        String(d.getMonth()+1).padStart(2,'0') + '-' +
                        String(d.getDate()).padStart(2,'0') + ' ' +
                        String(d.getHours()).padStart(2,'0') + ':' +
                        String(d.getMinutes()).padStart(2,'0') + ':' +
                        String(d.getSeconds()).padStart(2,'0')
                }
                return String(v).replace('T', ' ').substring(0, 19)
            }
            this.activityForm = {
                activityName: row.activity_name,
                startTime: fmtDate(row.start_time),
                endTime: fmtDate(row.end_time),
                giftName: row.gift_name || '',
                status: row.status
            }
            this.activityEditId = row.activity_id
            this.activityFormVisible = true
        },
        async saveActivity() {
            const { activityName, startTime, endTime, giftName, status } = this.activityForm
            if (!activityName) return this.$message.warning('请填写活动名称')
            if (!startTime || !endTime) return this.$message.warning('请选择开始和结束时间')
            this.activitySaving = true
            try {
                let res
                if (this.activityFormMode === 'add') {
                    const activityId = 'act_' + Date.now()
                    const r = await this.$http.post('admin/saveActivity', {
                        activityId, activityName, startTime, endTime,
                        giftName: giftName || '', claimLimit: 10, claimInterval: 5, status
                    })
                    res = r.data
                } else {
                    const r = await this.$http.post('admin/updateActivity', {
                        activityId: this.activityEditId, activityName, startTime, endTime,
                        giftName: giftName || '', status
                    })
                    res = r.data
                }
                if (res.status === 0) {
                    this.$message.success(this.activityFormMode === 'add' ? '活动创建成功' : '活动更新成功')
                    this.activityFormVisible = false
                    this.loadActivityList()
                    this.loadActivityOptions()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (e) {
                this.$message.error('网络错误，请重试')
            } finally {
                this.activitySaving = false
            }
        },
        async toggleActivityStatus(row) {
            const newStatus = row.status == 1 ? 0 : 1
            try {
                const { data: res } = await this.$http.post('admin/toggleActivityStatus', {
                    activityId: row.activity_id, status: newStatus
                })
                if (res.status === 0) {
                    row.status = newStatus
                    this.$message.success(newStatus === 1 ? '已开启' : '已关闭')
                    this.loadActivityOptions()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (e) {
                this.$message.error('网络错误')
            }
        },
        async deleteActivity(row) {
            try {
                await this.$confirm(`确定删除活动「${row.activity_name}」吗？`, '提示', { type: 'warning' })
                const { data: res } = await this.$http.post('admin/deleteActivity', { activityId: row.activity_id })
                if (res.status === 0) {
                    this.$message.success('删除成功')
                    this.loadActivityList()
                    this.loadActivityOptions()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            } catch (e) {
                if (e !== 'cancel') this.$message.error('网络错误')
            }
        },

        // 领取记录
        async openClaimDialog() {
            this.claimDialogVisible = true
            await Promise.all([this.loadActivityOptions(), this.loadClaimList()])
        },
        async loadActivityOptions() {
            try {
                const { data: res } = await this.$http.get('admin/activityList')
                if (res.status === 0) this.activityOptions = res.data
            } catch (e) {}
        },
        async loadClaimList() {
            const { activityId, giftStatus, page, size } = this.claimQuery
            const params = { activityId, page, size }
            if (giftStatus !== null && giftStatus !== undefined) params.giftStatus = giftStatus
            const { data: res } = await this.$http.get('admin/giftClaimList', { params })
            if (res.status === 0) {
                this.claimList = res.data.list
                this.claimTotal = res.data.total
            }
        },
        onClaimPageChange(page) {
            this.claimQuery.page = page
            this.loadClaimList()
        },

        // 标记发货
        openSendDialog(row) {
            this.sendForm = {
                id: row.id,
                recipientName: row.recipient_name,
                expressCompany: '',
                expressNo: '',
                sendOperator: ''
            }
            this.sendDialogVisible = true
        },
        async confirmSend() {
            if (!this.sendForm.expressNo) {
                return this.$message.warning('请填写快递单号')
            }
            const { data: res } = await this.$http.post('admin/giftClaimSend', this.sendForm)
            if (res.status === 0) {
                this.$message.success('标记发货成功')
                this.sendDialogVisible = false
                this.loadClaimList()
            } else {
                this.$message.error(res.msg || '操作失败')
            }
        },
      // 导出订单数据
      exportInfos() {
        let downloadLoadingInstance = Loading.service({
          text: "正在下载数据，请稍候",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axios
            .get("/admin/exportGiftClaim", {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              responseType: "blob",
              params: this.queryInfo,
            })
            .then(async (data) => {
              const isBlob = data.data.type !== "application/json";
              if (isBlob) {
                const blob = new Blob([data.data]);
                saveAs(blob, `赠送记录_${new Date().getTime()}.xlsx`);
              } else {
                this.$message.error("导出赠送记录数据失败");
              }
              downloadLoadingInstance.close();
            })
            .catch((r) => {
              console.error(r);
              this.$message.error("下载文件出现错误，请联系管理员！");
              downloadLoadingInstance.close();
            });
      },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    /deep/.el-dialog__body{
        padding-bottom:0px !important;
    }
</style>
